import type React from 'react';
import { FormattedMessage } from 'react-intl';

import { Link } from '@xing-com/link';

import { TrackingLink } from '../../tracking-link';
import { ArticleCard } from '../article-card';

import {
  FIRST_TITLE,
  SECOND_TITLE,
  SECOND_TEXT_CONTENT,
  LebenslaufData,
  FIRST_TEXT_CONTENT_2,
  FIRST_TEXT_CONTENT_1,
} from './lebenslauf-section-data';
import {
  Container,
  Title,
  Text,
  CardContainer,
} from './lebenslauf-section.styles';

export const LebenslaufSection: React.FC = () => (
  <Container>
    <Title size="xxlarge">{FIRST_TITLE}</Title>

    <Text size="xlarge" noMargin>
      <FormattedMessage
        id="invalid"
        defaultMessage={FIRST_TEXT_CONTENT_1}
        values={{
          strong: (chunks) => <strong>{chunks}</strong>,
        }}
      />
    </Text>
    <Text size="xlarge">
      <FormattedMessage
        id="invalid"
        defaultMessage={FIRST_TEXT_CONTENT_2}
        values={{
          a: (chunks) => (
            <TrackingLink
              as={Link}
              url="https://www.xing.com/lebenslauf"
              trackingParams={{
                sc_o: 'career_hub_application_home_lebenslauf_click',
                sc_o_PropActionOrigin:
                  'career_hub_application_home_lebenslauf_section',
              }}
            >
              {chunks}
            </TrackingLink>
          ),
          strong: (chunks) => <strong>{chunks}</strong>,
        }}
      />
    </Text>
    <CardContainer>
      {LebenslaufData.map((data) => (
        <ArticleCard {...{ data }} key={data.articleUrl} section="lebenslauf" />
      ))}
    </CardContainer>
    <Title size="xxlarge">{SECOND_TITLE}</Title>
    {/* @ts-expect-error FIXME: SC6 */}
    <Text
      size="xlarge"
      dangerouslySetInnerHTML={{ __html: SECOND_TEXT_CONTENT }}
      noMargin
    />
  </Container>
);
